export const searchTooltipText = 'Search by organisation name';
